const getErrors = errorParam => {
  const errors = errorParam?.response?.data?.errors
  return errors ? Object.keys(errors).reduce((messages, key) => ({ ...messages, [key]: errors[key][0] }), {}) : {}
}

export const getValidationErrors = error => {
  const msgs = Object.values(getErrors(error))
  const unique = [...new Set(msgs)]
  return unique.length ? unique.join(', ') : error?.response?.data?.message
}

export default function formError(refFormObserver, error) {
  const getErrorMessage = () => getValidationErrors(error)

  const setErrors = () => {
    const errors = getErrors(error)
    refFormObserver.setErrors(errors)
  }

  return {
    setErrors,
    getErrorMessage,
  }
}
